import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-12 px-4 text-center bg-navy-950 border-t border-navy-800" data-id="element-34">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-35">
          <p className="text-navy-600 text-sm" data-id="element-36">
            © {new Date().getFullYear()} Sleep & Serenity. All rights reserved.
          </p>
          <div className="flex items-center justify-center gap-6 text-sm" data-id="element-37">
            <button onClick={() => setActiveModal('privacy')} className="text-navy-500 hover:text-gold-400 transition-colors underline underline-offset-4 focus:outline-none focus:ring-2 focus:ring-gold-500 focus:ring-offset-2 focus:ring-offset-navy-950 rounded px-2 py-1" data-id="element-38">
              Privacy Policy
            </button>
            <span className="text-navy-700" data-id="element-39">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-navy-500 hover:text-gold-400 transition-colors underline underline-offset-4 focus:outline-none focus:ring-2 focus:ring-gold-500 focus:ring-offset-2 focus:ring-offset-navy-950 rounded px-2 py-1" data-id="element-40">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-41">
        <div className="prose prose-navy max-w-none space-y-6" data-id="element-42">
          <p className="text-sm text-navy-600" data-id="element-43">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section data-id="element-44">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-45">
              Information We Collect
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-46">
              When you purchase The Sleep & Serenity Blueprint, we collect
              information necessary to process your order, including your name,
              email address, and payment information. We use secure payment
              processors to handle all transactions.
            </p>
          </section>

          <section data-id="element-47">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-48">
              How We Use Your Information
            </h3>
            <p className="text-navy-700 leading-relaxed mb-3" data-id="element-49">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-navy-700" data-id="element-50">
              <li data-id="element-51">Deliver your digital product</li>
              <li data-id="element-52">Send order confirmations and receipts</li>
              <li data-id="element-53">Provide customer support</li>
              <li data-id="element-54">
                Send occasional updates about the product (you can opt out
                anytime)
              </li>
            </ul>
          </section>

          <section data-id="element-55">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-56">
              Data Security
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-57">
              We take the security of your personal information seriously. We
              use industry-standard encryption and security measures to protect
              your data. Payment information is processed through secure,
              PCI-compliant payment processors and is never stored on our
              servers.
            </p>
          </section>

          <section data-id="element-58">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-59">
              Third-Party Services
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-60">
              We use trusted third-party services to process payments and
              deliver digital products. These services have their own privacy
              policies and security measures in place.
            </p>
          </section>

          <section data-id="element-61">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-62">
              Your Rights
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-63">
              You have the right to access, update, or delete your personal
              information at any time. You can also opt out of marketing
              communications while still receiving essential order-related
              emails.
            </p>
          </section>

          <section data-id="element-64">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-65">Contact</h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-66">
              If you have questions about this Privacy Policy, please contact us
              through our support channels.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-67">
        <div className="prose prose-navy max-w-none space-y-6" data-id="element-68">
          <p className="text-sm text-navy-600" data-id="element-69">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section data-id="element-70">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-71">
              Agreement to Terms
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-72">
              By purchasing and using The Sleep & Serenity Blueprint, you agree
              to these Terms of Service. Please read them carefully before
              completing your purchase.
            </p>
          </section>

          <section data-id="element-73">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-74">
              Product Description
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-75">
              The Sleep & Serenity Blueprint is a digital product designed to
              provide guidance and strategies for improving sleep quality. It is
              delivered as a downloadable PDF and accompanying materials.
            </p>
          </section>

          <section data-id="element-76">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-77">
              Medical Disclaimer
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-78">
              This product is for informational and educational purposes only.
              It is not intended to diagnose, treat, cure, or prevent any
              medical condition. Always consult with a qualified healthcare
              provider before making changes to your sleep routine, especially
              if you have a diagnosed sleep disorder or other medical
              conditions.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-80">
              Refund Policy
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-81">
              Due to the digital nature of this product, all sales are final.
              However, if you experience technical issues accessing your
              purchase, please contact our support team and we'll work to
              resolve the issue.
            </p>
          </section>

          <section data-id="element-82">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-83">
              Intellectual Property
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-84">
              All content in The Sleep & Serenity Blueprint is protected by
              copyright. You may not reproduce, distribute, or share the
              materials without written permission. Your purchase grants you a
              personal, non-transferable license to use the materials for your
              own benefit.
            </p>
          </section>

          <section data-id="element-85">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-86">
              Limitation of Liability
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-87">
              We make no guarantees about specific results. Individual results
              may vary based on personal circumstances, commitment to the
              program, and other factors. We are not liable for any indirect,
              incidental, or consequential damages arising from your use of this
              product.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="text-xl font-serif text-navy-900 mb-3" data-id="element-89">
              Changes to Terms
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-90">
              We reserve the right to update these Terms of Service at any time.
              Continued use of the product after changes constitutes acceptance
              of the updated terms.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}